<template>
  <div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong v-html="snackbar.title"></strong>
          </div>
          <div v-html="snackbar.text"></div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-data-table
        v-model="data.documents"
        :headers="headersDocuments"
        :items="data.documents"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :key="keyTable"
        mobile-breakpoint="0"
        class="mt-5">
      <template v-slot:item="{ item }">
        <tr v-if="!item.loadingVisible && item.loading === 'success'">
          <td>{{ item.date }}</td>
          <td>{{ item.fileName }}</td>
          <td>
            <v-text-field
                v-model="item.title"
                @change="updateDocument(item)"
                label="Title"
                placeholder="Title"></v-text-field>
          </td>
          <td>
            <v-select
                :label="languageData.labels.document_type"
                v-model="item.type"
                :items="documentTypesWithoutAll"
                @change="updateDocument(item)"
                item-value="value"
                item-text="name">
              <template slot='selection' slot-scope='{ item }'>
                {{ documentableType === 'project' ? languageData.documentProjectTypes[item.value] : languageData.documentClientTypes[item.value] }}
              </template>
              <template slot='item' slot-scope='{ item }'>
                {{ documentableType === 'project' ? languageData.documentProjectTypes[item.value] : languageData.documentClientTypes[item.value] }}
              </template>
            </v-select>
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="showDeleteDocumentModal(item)"
                    icon>
                  <v-icon color="fontDefault">delete</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }" v-if="item.canOpenFile">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="openDocument(item)"
                    icon>
                  <v-icon color="fontDefault">mdi-file-eye</v-icon>
                </v-btn>
              </template>
              <span>Open</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="downloadDocument(item)"
                    icon>
                  <v-icon color="fontDefault">mdi-file-download</v-icon>
                </v-btn>
              </template>
              <span>Download</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="showEmailForm(item)"
                    icon>
                  <v-icon color="fontDefault">mdi-email-edit</v-icon>
                </v-btn>
              </template>
              <span>{{ languageData.labels.typeEmail }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }" v-if="documentableType === 'project'">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="showModalChooseClient(item)"
                    icon>
                  <v-icon color="fontDefault">mdi-email-send</v-icon>
                </v-btn>
              </template>
              <span>{{ languageData.labels.choosePersonAndSend }}</span>
            </v-tooltip>
          </td>
        </tr>
        <tr v-else-if="!item.loadingVisible && item.loading === 'error'">
          <td colspan="5">
            <v-alert
                dense
                outlined
                type="error"
                class="w-100 mt-auto mb-auto"
            >
              <p class="mt-auto mb-auto" v-html="item.errorInfo"></p>
              <template v-slot:close>
                <i class="material-icons" @click="closeAlertErrorInfo(item)">close</i>
              </template>
            </v-alert>
          </td>
        </tr>
        <tr class="w-100" v-else>
          <td colspan="5" v-if="item.loading !== 'error'">
            <v-progress-linear
                indeterminate
                class="w-100"
                color="cyan"
            ></v-progress-linear>
          </td>
        </tr>
      </template>
    </v-data-table>
    <ModalInfo @doOperation="removeDocument(documentToDelete)" :isLoadingBtn="false" :typeInfo="'success'" :headModal="languageData.modalDeleteDocument.head" :btnDisAgreeText="languageData.modalDeleteDocument.btnDisAgreeText" :btnAgreeText="languageData.modalDeleteDocument.btnAgreeText" :visDisAgreeBtn="true" @clicked="hideModalDeleteDocument" :show-modal="isShowDeleteDocumentModal" :text-modal="languageData.modalDeleteDocument.textInfo + '' + documentToDelete.id "></ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideModalChooseClient" :show-modal="isChooseClient">
      <template v-slot:body>
        <template>
          <ClientsTableSelect :projectClients="projectClients" :layout="'choosePerson'"></ClientsTableSelect>
        </template>
        <template>
          {{ languageData.favoriteContacts }}
          <FavoriteContactsTable layout="sendEmail" emailType="document"></FavoriteContactsTable>
        </template>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalForm'" @clicked="updateVisibleDocumentSendEmailModal" :show-modal="isShowDocumentSendEmailModal">
      <template v-slot:header>
        {{ languageData.documents.sendDocument + ' ' + activeDocument }}
      </template>
      <template v-slot:body>
        <SendDocumentForm :documentableType="documentableType"></SendDocumentForm>
      </template>
    </ModalInfo>
  </div>
</template>

<script type="text/javascript">
import {documentTypes} from "../../enums/documentTypes";
import eventBus from "../../../../event-bus/eventBus";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import {mapActions, mapState} from "vuex";
import downloadFileHelper from "../../../../helpers/downloadFileHelper";
import openFileHelper from "../../../../helpers/openFileHelper";
import ClientsTableSelect from "../../../Projects/components/ClientsTableSelect/ClientsTableSelect";
import FavoriteContactsTable from "../../../Company/components/FavoriteContacts/FavoriteContactsTable";
import SendDocumentForm from "../TypeEmailAndSendDocument/TypeEmailAndSendDocument.vue";

export default {
    name: "DocumentsTable",
    props: {
      documentableType: String,
      projectClients: Array,
    },
    components: {
      ModalInfo, ClientsTableSelect, FavoriteContactsTable, SendDocumentForm
    },
    data() {
      return {
        sortBy: "id",
        sortDesc: true,
        documentTypesWithoutAll: documentTypes[this.documentableType].slice(1),
        documentToDelete: {},
        data: {
          documents: []
        },
        documentsError: "",
        documents: [],
        documentTypes: documentTypes,
        documentType: "",
        isShowDeleteDocumentModal: false,
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: null,
          text: null,
          corner: null,
          timeout: 7500,
          title: null,
          visible: false
        },
        keyTable: 0,
        isChooseClient: false,
        activeDocument: null,
      }
    },
    watch: {
      "data.documents": {
        deep: true,
        handler: function(newValue, oldValue) {
          if (newValue.length !== oldValue.length) {
            if (this.$route.name === 'ProjectsEdit') {
              this.getProjectDiskUsageRequest();
            } else if (this.$route.name === 'ClientsEdit') {
              this.getClientDiskUsageRequest();
            }
          }
        }
      }
    },
    computed: {
      ...mapState("getHeadersDocuments", {
        headersDocuments: state => state.headers
      }),
      ...mapState("updateVisibleDocumentSendEmailModal", {
      isShowDocumentSendEmailModal: state => state.isShowDocumentSendEmailModal
      }),
    },
    methods: {
      ...mapActions("getBase64Document", ["getBase64Document"]),
      ...mapActions("openDocument", ["openFile"]),
      ...mapActions("deleteDocument", ["deleteDocument"]),
      ...mapActions("updateDocument", ["updateDocumentFile"]),
      ...mapActions("saveDocument", ["storeDocument"]),
      ...mapActions("getDocuments", ["getDocuments"]),
      ...mapActions("getProjectsClient", ["getProjectsClient"]),
      ...mapActions("sendDocument", ["prepareDocument"]),
      ...mapActions("updateVisibleDocumentSendEmailModal", ["updateVisibleDocumentSendEmailModal"]),
      ...mapActions("getProjectDiskUsage", ["getProjectDiskUsageRequest"]),
      ...mapActions("getClientDiskUsage", ["getClientDiskUsageRequest"]),

      showDeleteDocumentModal: function(item) {
        this.isShowDeleteDocumentModal = true;
        this.documentToDelete = item;
      },
      hideModalDeleteDocument: function() {
        this.isShowDeleteDocumentModal = false;
      },
      removeDocument: function(item) {
        let indexItem = this.data.documents.indexOf(item);
        let id = item.id;
        this.deleteDocument({ creds: { id, indexItem } });
        this.documentToDelete = {};
      },
      updateDocument: function(item) {
        this.updateDocumentFile({ creds: { item } });
      },
      saveDocument: function(item) {
        const document = item;
        const index = this.data.documents.indexOf(item);
        this.storeDocument({ creds: { document, index } })
      },
      closeAlertErrorInfo: function(item) {
        this.data.documents.splice(this.data.documents.indexOf(item), 1);
        this.keyTable += 1;
      },
      downloadDocument(item) {
        let id = item.id;
        let operation = "download";
        this.getBase64Document({ creds: { id, operation } });
      },
      openDocument(item) {
        let id = item.id;
        let operation = "open";
        this.getBase64Document({ creds: { id, operation } });
      },
      hideModalChooseClient: function() {
        this.isChooseClient = false;
      },
      showModalChooseClient(item) {
        this.prepareDocument(item);
        this.isChooseClient = true;
      },
      showEmailForm(item) {
        this.activeDocument = item.title ? item.title : item.fileName;
        this.prepareDocument(item);
        this.updateVisibleDocumentSendEmailModal(true);  
      },
      getSnackBar: function(title, message, icon, color) {
        this.snackbar = {
          color: color,
          icon: icon,
          mode: "multi-line",
          position: "top",
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      }
    },
    mounted() {
      eventBus.$on("pushDocument", (document) => {
        ([...this.data.documents]).forEach(document => {
          if(document.errorInfo !== undefined) {
            this.data.documents.splice(this.data.documents.indexOf(document), 1);
          }
        });
        this.keyTable += 1;
        this.data.documents.push(document);
        this.sortBy = "date";
        this.sortDesc = false;
        this.storeDocument({ creds: { document } });
      })
      eventBus.$on("operationFailure", (dataReceive) => {
        this.getSnackBar(dataReceive.title, dataReceive.message, "error", "error");
      });
      eventBus.$on("getDocumentsSuccess", (documents) => {
        this.data.documents = documents;
      });
      eventBus.$on("operationDocument", (data, operation) => {
        if(operation === "download") {
          downloadFileHelper(data);
        }
        else if(operation === "open") {
          openFileHelper(data)
        }
      });
      eventBus.$on("saveDocumentFailure", (dataReceive) => {
        let indexDocument = this.data.documents.indexOf(dataReceive.document);
        this.data.documents[indexDocument]["loading"] = "error";
        this.data.documents[indexDocument]["loadingVisible"] = false;
        this.data.documents[indexDocument]["errorInfo"] = dataReceive.message;
        eventBus.$emit("operationFailure", dataReceive);
      })
      eventBus.$on("saveDocumentSuccess", (dataReceive) => {
        let indexDocument = this.data.documents.indexOf(dataReceive.document);
        if (indexDocument !== -1) {
          this.data.documents[indexDocument]["id"] = dataReceive.id;
          this.data.documents[indexDocument]["path"] = dataReceive.path;
          this.data.documents[indexDocument]["loading"] = "success";
          this.data.documents[indexDocument]["date"] = "0 minute ago";
          this.sortBy = "id";
          this.sortDesc = true;
          this.data.documents[indexDocument]["loadingVisible"] = false;
          this.getSnackBar(dataReceive.title, dataReceive.message, "check_circle", "success");
        }
        if (this.$route.name === 'ProjectsEdit') {
          this.getProjectDiskUsageRequest();
        } else if (this.$route.name === 'ClientsEdit') {
          this.getClientDiskUsageRequest();
        }
      });
      eventBus.$on("successDeleteDocument", (dataReceive) => {
        this.data.documents.splice(dataReceive.indexItem, 1);
        this.getSnackBar(dataReceive.title, dataReceive.message, "check_circle", "success");
        this.keyTable += 1;
        if (this.$route.name === 'ProjectsEdit') {
          this.getProjectDiskUsageRequest();
        } else if (this.$route.name === 'ClientsEdit') {
          this.getClientDiskUsageRequest();
        }
      });
      eventBus.$on("updateDocumentSuccess", (dataReceive) => {
        this.getSnackBar(dataReceive.title, dataReceive.message, "check_circle", "success");
      });
      eventBus.$on("sendDocumentSuccess", (snackbarData) => {
        this.getSnackBar(snackbarData.title, snackbarData.message, "check_circle", "success");
        this.updateVisibleDocumentSendEmailModal(false);  
      });
      eventBus.$on("sendDocumentFailure", (snackbarData) => {
        this.getSnackBar(snackbarData.title, snackbarData.message, "check_circle", "red");
      });
    },
    beforeDestroy() {
      eventBus.$off("pushDocument");
      eventBus.$off("operationDocument");
    }
  }
</script>
